module.exports = __webpack_public_path__ + "img/Ele2.800003d1.jpg";